function VisitCardVO(id, reconnaissance, physicalExamination, recommendations, diagnosisList, medicalProcedures,
                     prescriptions, visit, sickLeave, laboratoryTestResults, referrals, attachment, prescribedDrugs,
                     icfDiagnosis, visitStreamingSessionId, downloadReady, epicrisis, insuranceStatements, attachments,
                     echoExaminations, clinicReferrals) {
    this.id = id;

    this.visit = visit;
    this.reconnaissance = reconnaissance;
    this.physicalExamination = physicalExamination;
    this.recommendations = recommendations;
    this.diagnosisList = diagnosisList;
    this.icfDiagnosis = icfDiagnosis;
    this.medicalProcedures = medicalProcedures;
    this.prescriptions = prescriptions;
    this.sickLeave = sickLeave;
    this.laboratoryTestResults = laboratoryTestResults;
    this.referrals = referrals;
    this.attachment = attachment;
    this.prescribedDrugs = prescribedDrugs;
    this.visitStreamingSessionId = visitStreamingSessionId;
    this.downloadReady = downloadReady;
    this.epicrisis = epicrisis;
    this.insuranceStatements = insuranceStatements;
    this.attachments = attachments;
    this.echoExaminations = echoExaminations;
    this.clinicReferrals = clinicReferrals;

    var _typeContext = {
        sickLeave: SickLeaveVO,
        diagnosisList: DiagnosisVO,
        icfDiagnosis: ICFDiagnosisVO,
        medicalProcedures: MedicalProcedureVO,
        visit: VisitVO,
        prescriptions: PrescriptionVO,
        attachment: AttachmentVO,
        referrals: ReferralVO,
        prescribedDrugs: PrescribedDrugVO,
        epicrisis: AttachmentVO,
        insuranceStatements: InsuranceStatementVO,
        laboratoryTestResults: LaboratoryTestResultVO,
        echoExaminations: HeartEchoVO,
        clinicReferrals: ReferralToClinicVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}

VisitCardVO.fromTemplate = function (template) {
    var visitCard = {};
    visitCard.reconnaissance = template.reconnaissance;
    visitCard.physicalExamination = template.physicalExamination;
    visitCard.recommendations = template.recommendations;
    visitCard.diagnosisList = template.diagnosisList.map(removeId);
    visitCard.medicalProcedures = template.medicalProcedures.map(removeId);
    visitCard.prescribedDrugs = template.prescribedDrugs.map(removeId);
    return visitCard;

    function removeId(item) {
        var itemClone = angular.copy(item);
        delete itemClone.id;
        return itemClone;
    }
};
